import React from 'react'
import { AlarmQuery } from '../../../shared/models/alarm.model'
import StatisticCard from '../../../components/common/widgets/StatisticCard'
import { useLazyGetAlarmsQuery } from '../../../store/kopiliot-api/alarm'

const AlarmCard: React.FC<
  Partial<AlarmQuery & { title: string; className: string }>
> = ({ title, className, tenantID, customerID, severity }) => {
  const [getAlarms, resultGetAlarms] = useLazyGetAlarmsQuery()
  React.useEffect(() => {
    if (!tenantID) {
      return
    }
    const query: AlarmQuery = {
      tenantID,
      customerID,
      severity,
      textSearch: '',
      limit: 100,
      offset: 0,
    }
    getAlarms(query)
  }, [severity, tenantID, customerID, getAlarms])
  return (
    <StatisticCard
      title={title ?? ''}
      value={resultGetAlarms?.data?.totalRows}
      className={className}
    />
  )
}

export default AlarmCard
